<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="应用名称" prop="name">
        <el-input v-model.trim="form.name" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态" v-if="dialogData.row">
        <el-select v-model="form.status">
          <el-option v-for="item in appStatus" :key="item.id" :value="item.id" :label="item.msg"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用KEY(18位)" prop="app_key" v-else>
        <el-input v-model.trim="form.app_key" clearable maxlength="18" show-word-limit>
          <el-button slot="append" @click="form.app_key = randomString(18)">随机</el-button>
        </el-input>
      </el-form-item>
      <el-form-item label="应用密钥(32位)" prop="app_secret">
        <el-input v-model.trim="form.app_secret" clearable maxlength="32" show-word-limit>
          <el-button slot="append" @click="form.app_secret = randomString(32)">随机</el-button>
        </el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty} from "@utils/validate"
  import {appStatus} from "@utils/formatList"
  export default {
    name: "AppOperate",
    props: {dialogData: Object},
    data() {
      return {
        appStatus,
        form: {
          name: "",
          app_key: "",
          app_secret: "",
          status: "",
        },
        rules: {
          name: [inputEmpty("应用名称")],
          app_key: [inputEmpty("应用KEY")],
          app_secret: [inputEmpty("应用密钥")],
        },
      }
    },
    created() {
      let row = this.dialogData.row;
      if (row) {
        Object.keys(this.form).forEach(key => key in row && (this.form[key] = row[key]));
      }
    },
    methods: {
      confirm() {
        let row = this.dialogData.row;
        row ? this.revise(row) : this.add();
      },
      add() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            let nv = {...this.form};
            let res = await this.$Http.addApp(nv);
            if (res) {
              this.msgSuccess("添加成功");
              this.$emit("table-reload");
              this.dialogData.visible = false;
            }
          }
        });
      },
      revise(row) {
        let nv = {};
        Object.entries(this.form).forEach(([key, value]) => value !== row[key] && (nv[key] = value));
        if (Object.keys(nv).length) {
          this.$refs["form"].validate(isOk => {
            if (isOk) {
              this.openConfirm("修改该应用账号", async () => {
                nv.open_account_id = row.id;
                let res = await this.$Http.reviseApp(nv);
                if (res) {
                  this.msgSuccess("修改成功");
                  this.$emit("table-reload");
                  this.dialogData.visible = false;
                }
              });
            }
          });
        } else {
          this.msgInfo("您尚未做任何修改")
        }
      },
    }
  }
</script>

<style scoped>

</style>
